import clsx from 'clsx';
import React from 'react';

const Tr = ({ children, isInactive = false, isMarked = false, extraClasses, disableHover = false, ...rest }) => {
  return (
    <div
      className={clsx(
        'tr',
        isInactive && 'tr--inactive',
        isMarked && 'tr--marked',
        disableHover && 'tr--hover-disabled',
        extraClasses,
      )}
      {...rest}>
      {children}
    </div>
  );
};

export default Tr;
